module.exports = __webpack_public_path__ + "static/media/inter.070b004d.jpg";